import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import Table1 from "../../../core/pagination/datatable";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { API_BASE_URL, API_NOTIFY_URL } from "../Config/Config";
import { Select, Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";
import { DatePicker } from "antd";
import * as bootstrap from "bootstrap";

const HealthCheck = () => {
  const { RangePicker } = DatePicker;
  const columns = [
    {
      title: "SuperId",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      render: (_, record) => {
        const truncated =
          record?.OrgName?.length > 30
            ? record?.OrgName?.substring(0, 30) + "..."
            : record?.OrgName;
        return (
          <div className="d-flex align-items-center gap-4">
            <span
              className={
                record?.DeviceStatus
                  ? "badge bg-success rounded-circle"
                  : "badge bg-danger rounded-circle"
              }
              style={{
                width: 15,
                height: 15,
                display: "inline-block",
              }}
            ></span>
            <span title={record?.OrgName}>{truncated}</span>
          </div>
        );
      },
      sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
    },

    // {
    //   title: "Service",
    //   dataIndex: "ServiceTypeName",
    //   render: (text) => {
    //     const truncated =
    //       text?.length > 15 ? text?.substring(0, 15) + "..." : text;
    //     return <span title={text}>{truncated}</span>;
    //   },
    //   sorter: (a, b) =>
    //     (a?.ServiceTypeName || "").localeCompare(b?.ServiceTypeName || ""),
    // },
    {
      title: "Service",
      dataIndex: "ServiceTypeName",

      render: (text) => {
        if (!text) return "-";

        let iconClass = "";
        let color = "";

        if (text === "RCLite") {
          iconClass = "ti ti-leaf";
          color = "#52c41a";
        } else if (text === "RCStd") {
          iconClass = "ti ti-stack";
          color = "#1890ff";
        } else if (text === "RCPremium") {
          iconClass = "ti ti-crown";
          color = "#faad14";
        }

        return (
          <div
            title={text}
            style={{
              // ✅ horizontal center
              alignItems: "center", // ✅ vertical center
            }}
          >
            <i
              className={iconClass}
              style={{
                color,
                fontSize: "20px", // ✅ increase size
              }}
            ></i>
          </div>
        );
      },

      sorter: (a, b) =>
        (a?.ServiceTypeName || "").localeCompare(b?.ServiceTypeName || ""),
    },
    {
      title: "Last Activity",
      dataIndex: "LastPunchReceived",
      sorter: (a, b) => {
        const d1 = dayjs(a?.LastPunchReceived, "DD-MM-YY hh:mm A", true);
        const d2 = dayjs(b?.LastPunchReceived, "DD-MM-YY hh:mm A", true);

        return (
          (d1.isValid() ? d1.valueOf() : 0) - (d2.isValid() ? d2.valueOf() : 0)
        );
      },
    },
    // {
    //   title: "Punches",
    //   dataIndex: "Processed",
    //   sorter: (a, b) => (a?.Processed || 0) - (b?.Processed || 0),
    // },
    {
      title: "L.Pun.Proc",
      dataIndex: "LastProcessedPunch",
      sorter: (a, b) => {
        const d1 = dayjs(a?.LastProcessedPunch, "DD-MM-YY hh:mm A", true);
        const d2 = dayjs(b?.LastProcessedPunch, "DD-MM-YY hh:mm A", true);

        return (
          (d1.isValid() ? d1.valueOf() : 0) - (d2.isValid() ? d2.valueOf() : 0)
        );
      },
    },
    {
      title: "Devices",
      render: (_, record) => {
        const totalDevices =
          (record?.ActiveDevices || 0) + (record?.InactiveDevices || 0);

        return <span>{totalDevices}</span>;
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
    
      render: (_, record) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#device_detail"
            title="View Devices"
            onClick={() => {
              setSelectRecord(record);
              fetchOrgDevices(record?.SuperId);
            }}
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
  ];
  const deviceColumns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
    },

    {
      title: "Serial No",
      dataIndex: "SerialNo",
      key: "SerialNo",
    },

    {
      title: "Machine ID",
      dataIndex: "MachineId",
      key: "MachineId",
    },
    {
      title: "Device Type",
      dataIndex: "DeviceType",
      key: "DeviceType",
    },
    {
      title: "Device Model",
      dataIndex: "DeviceModel",
      key: "DeviceModel",
    },
    {
      title: "Processed",
      dataIndex: "Processed",
      key: "Processed",
      render: (value, record) => (
        <span
          className="text-primar"
          style={{ cursor: "pointer", textDecoration: "underline" }}
          data-bs-toggle="modal"
          data-bs-target="#lp_modal"
          
          title="view punch list"
          // onClick={() =>
          //   handleLPPunchClick(selectRecord?.SuperId, record?.MachineId)
          // }
          onClick={() => {
            handleLPPunchClick(
              selectRecord?.SuperId,
              record?.MachineId
            );
          
            const deviceModalEl =
              document.getElementById("device_detail");
          
            const deviceModal =
              bootstrap.Modal.getInstance(deviceModalEl);
          
            if (deviceModal) {
              deviceModalEl.addEventListener(
                "hidden.bs.modal",
                () => {
                  // Remove old backdrops
                  document
                    .querySelectorAll(".modal-backdrop")
                    .forEach((el) => el.remove());
          
                  // Reset body
                  document.body.classList.remove("modal-open");
          
                  // Open LP modal
                  const lpModalEl =
                    document.getElementById("lp_modal");
          
                  const lpModal = new bootstrap.Modal(lpModalEl, {
                    backdrop: true,
                    keyboard: false,
                  });
          
                  lpModal.show();
          
                  // Force backdrop creation
                  setTimeout(() => {
                    if (
                      !document.querySelector(".modal-backdrop")
                    ) {
                      const backdrop =
                        document.createElement("div");
          
                      backdrop.className =
                        "modal-backdrop fade show";
          
                      document.body.appendChild(backdrop);
          
                      document.body.classList.add("modal-open");
                    }
                  }, 50);
                },
                { once: true }
              );
          
              deviceModal.hide();
            }
          }}
        >
          {value}
        </span>
      ),
    },
    {
      title: "UnProcessed",
      dataIndex: "UnProcessed",
      key: "UnProcessed",
      render: (value, record) => (
        <span
          className="text-primar"
          style={{ cursor: "pointer", textDecoration: "underline" }}
          data-bs-toggle="modal"
          data-bs-target="#lp_modal"
          title="view unpunch list"
          // onClick={() =>
          //   handleLPPunchClick(selectRecord?.SuperId, record?.MachineId)
          // }
          onClick={() => {
            handleLPPunchClick(
              selectRecord?.SuperId,
              record?.MachineId
            );
          
            const deviceModalEl =
              document.getElementById("device_detail");
          
            const deviceModal =
              bootstrap.Modal.getInstance(deviceModalEl);
          
            if (deviceModal) {
              deviceModalEl.addEventListener(
                "hidden.bs.modal",
                () => {
                  // Remove old backdrops
                  document
                    .querySelectorAll(".modal-backdrop")
                    .forEach((el) => el.remove());
          
                  // Reset body
                  document.body.classList.remove("modal-open");
          
                  // Open LP modal
                  const lpModalEl =
                    document.getElementById("lp_modal");
          
                  const lpModal = new bootstrap.Modal(lpModalEl, {
                    backdrop: true,
                    keyboard: false,
                  });
          
                  lpModal.show();
          
                  // Force backdrop creation
                  setTimeout(() => {
                    if (
                      !document.querySelector(".modal-backdrop")
                    ) {
                      const backdrop =
                        document.createElement("div");
          
                      backdrop.className =
                        "modal-backdrop fade show";
          
                      document.body.appendChild(backdrop);
          
                      document.body.classList.add("modal-open");
                    }
                  }, 50);
                },
                { once: true }
              );
          
              deviceModal.hide();
            }
          }}
        >
          {value}
        </span>
      ),
    },

    {
      title: "Status",
      dataIndex: "Status",
    
      render: (value) => (
        <span
          title={value}
          style={{
            display: "inline-block",
            width: 15,
            height: 15,
            borderRadius: "50%",
            backgroundColor: value === "Active" ? "#28a745" : "red",
          }}
        ></span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2 p-2 d-flex align-items-center border rounded"
            data-bs-toggle="modal"
            data-bs-target="#Notification"
            title="Send Notification"
            onClick={() => sendNotification(record)}
          >
            <i className="ti ti-bell" />
          </Link>
        </div>
      ),
    },
  ];

  const swipeColumns = [
    {
      title: "SwipeID",
      dataIndex: "Id",
      key: "ID",
    },
    {
      title: "SuperId",
      dataIndex: "SuperId",
      key: "SuperId",
    },
    {
      title: "MachineId",
      dataIndex: "MachineId",
      key: "MachineId",
    },
    {
      title: "CardId",
      dataIndex: "CardId",
      key: "CardId",
    },
    {
      title: "Date of Transaction",
      dataIndex: "DateOfTransaction",
      key: "DateOfTransaction",
    },
    {
      title: "Date Logged",
      dataIndex: "DateLogged",
      key: "DateLogged",
    },
  ];

  const [totalTransaction] = React.useState({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#F7A37A"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#F7A37A"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });
  const [totalSubscription] = React.useState({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#70B1FF"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#70B1FF"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });
  const [activeSubscription] = React.useState({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#60DD97"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#60DD97"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });
  const [expiredSubscription] = React.useState({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#DE5555"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#DE5555"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });
  const [todaySubscription] = React.useState({
    series: [
      {
        name: "",
        data: [6, 2, 8, 4, 3, 8, 1, 3, 6, 5, 9, 2, 8, 1, 4, 8, 9, 8, 2, 1],
      },
    ],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      foreColor: "#fff",
      type: "area",
      width: 80,
      toolbar: {
        show: !1,
      },
      zoom: {
        enabled: !1,
      },
      dropShadow: {
        enabled: 0,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.12,
        color: "#fff",
      },
      sparkline: {
        enabled: !0,
      },
    },
    markers: {
      size: 0,
      colors: ["#DE5555"],
      strokeColors: "#fff",
      strokeWidth: 0,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "35%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: !1,
    },
    // stroke: {
    //   show: !0,
    //   width: 2.5,
    //   curve: "smooth"
    // },
    stroke: {
      width: 0,
      curve: "monotoneCubic",
    },
    colors: ["#e91193ff"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: !1,
      },
      x: {
        show: !1,
      },

      marker: {
        show: !1,
      },
    },
  });

  const [HealthCheckData, setHealthCheckData] = useState([]);
  const [selectRecord, setSelectRecord] = useState(null);
  const [serviceType, setServiceType] = useState([
    { label: "All Services", value: 0 },
  ]);
  const [LoadingService, setLoadingService] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedServiceType, setSelectedServiceType] = useState(0);
  const [counts, setCounts] = useState();
  const [orgDevicesLoading, setOrgDevicesLoading] = useState(false);
  const [punchListingLoading, setPunchListingLoading] = useState(false);
  const [orgDevices, setOrgDevices] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedPunchDetails, setSelectedPunchDetails] = useState([]);
  console.log(selectedPunchDetails, "selectedpunchdetails");

  const [NotifytModalData, setNotifyModalData] = useState({
    OrgName: "",
    PrimaryEmailAddr: "",
    PrimaryMobile: "",
    Subject: "",
    Message: "",
  });

  const fetchHealthCheckData = async (from, to) => {
    if (!from) return;
    setLoading(true);

    const fromDateValue = from || fromDate;
    const toDateValue = to || toDate;
    console.log(selectedServiceType);
    try {
      const response = await fetch(
        `${API_BASE_URL}api/dashboard/gethealthcheck?ServiceTypeId=${selectedServiceType}&FromDate=${fromDateValue}&ToDate=${toDateValue}`
      );

      const data = await response.json();

      if (response.ok && data?.status === true) {
        console.log(data?.ResultData, "resulttttttttttttttttttt");
        setHealthCheckData(data?.ResultData);
      } else {
        setHealthCheckData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const fetchServiceTypes = async () => {
    try {
      setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}api/type/getservicetypes`);

      if (!res.ok) throw new Error("Failed to fetch ServiceTypes");
      const data = await res.json();

      if (data?.status === true && Array.isArray(data.ResultData)) {
        setServiceType([
          { label: "All Services", value: 0 },
          ...data.ResultData.map((item) => ({
            label: item.ServiceName,
            value: item.Id,
          })),
        ]);
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      setLoadingService(false);
    }
  };

  const fetchCounts = async () => {
    try {
      // setCountLoading(true);
      const response = await fetch(
        `${API_BASE_URL}api/dashboard/getdashboardcounts`
      );

      const data = await response.json();
      setCounts(data?.ResultData[0]);
    } catch (error) {
      console.error("Error fetching counts:", error);
    } finally {
      // setCountLoading(false);
    }
  };

  const fetchOrgDevices = async (superId, from, to) => {
    const fromDateValue = from || fromDate;
    const toDateValue = to || toDate;

    if (superId === undefined || superId === null) return;

    try {
      setOrgDevicesLoading(true);
      setOrgDevices([]);

      const url = `${API_BASE_URL}api/device/getorganizationdevices?SuperId=${superId}&FromDate=${fromDateValue}&ToDate=${toDateValue}`;

      const res = await fetch(url);

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setOrgDevices(data.ResultData);
      } else {
        setOrgDevices([]);
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Failed to fetch organization devices:", error);
      setOrgDevices([]);
    } finally {
      setOrgDevicesLoading(false);
    }
  };

  const handleLPPunchClick = async (superID, machineId, from, to) => {
    const fromDateValue = from || fromDate;
    const toDateValue = to || toDate;

    if (
      superID === undefined ||
      superID === null ||
      machineId === undefined ||
      machineId === null
    ) {
      return;
    }

    try {
      setPunchListingLoading(true);
      setSelectedPunchDetails([]);

      const url = `${API_BASE_URL}api/swipe/getpunchlistingforday?SuperId=${superID}&MachineId=${machineId}&FromDate=${fromDateValue}&ToDate=${toDateValue}`;

      const res = await fetch(url);

      if (!res.ok) {
        throw new Error(`HTTP Error: ${res.status}`);
      }

      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setSelectedPunchDetails(data.ResultData);
      } else {
        setSelectedPunchDetails([]);
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Failed to fetch punch listing:", error);
      setSelectedPunchDetails([]);
    } finally {
      setPunchListingLoading(false);
    }
  };

  const sendNotification = (record) => {
    console.log(record, "record");

    let finalMessage = "";

    // CASE 1: Client Inactive
    if (!record?.IsActive) {
      finalMessage = `
  Hi, ${record?.OrgName}
  
  We noticed that your device is currently inactive.
  
  Please contact our support team to reactivate your services
  and resume normal operations.
  
  Device Details:
  Model: ${record?.DeviceModel}
  Serial No: ${record?.SerialNo}
  MachineId: ${record?.MachineId}
  
  Warm regards,
  PerennialCode Support Team
  
  Contact Us:
  Phone: 8297230010
  Email: support@perennialcode.in
  `.trim();
    } else {
      finalMessage = `
  Hi, ${record?.OrgName}
  
  Your device appears to be offline, and attendance data
  has not been received for the past few days.
  
  Please check the following:
  • Power supply to the device
  • Internet/network connection
  • Device wiring and connectivity
  
  Device Details:
  Model: ${record?.DeviceModel}
  Serial No: ${record?.SerialNo}
  MachineId: ${record?.MachineId}
  
  If the issue persists, kindly contact our support team.
  
  Warm regards,
  PerennialCode Support Team
  
  Contact Us:
  Phone: 8297230010
  Email: support@perennialcode.in
  `.trim();
    }

    setNotifyModalData({
      OrgName: record?.OrgName || "",
      PrimaryEmailAddr: record?.Email || "",
      PrimaryMobile: record?.Mobile || "",
      Subject: "Important Notification From Our Team",
      Message: finalMessage,
    });
  };

  const sendWhatsAppNotification = async () => {
    if (!NotifytModalData?.PrimaryMobile || !NotifytModalData?.Message) {
      alert("Contact number and message are required!");
      return;
    }

    try {
      const payload = {
        number: String(NotifytModalData.PrimaryMobile).replace(/\D/g, ""),
        client: NotifytModalData?.OrgName,
        subject: NotifytModalData?.Subject,
        message: NotifytModalData?.Message,
      };

      console.log("Sending JSON:", payload);

      const res = await axios.post(
        `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
        payload
      );

      console.log(res.data);

      if (res.data?.success || res.data?.status) {
        alert("WhatsApp message sent successfully!");
      } else {
        alert(res.data?.message || "Failed to send message!");
      }
    } catch (err) {
      console.error("WhatsApp Error:", err);
      alert(err?.response?.data?.message || "Something went wrong!");
    }
  };
  const handleChange1 = (e) => {
    setNotifyModalData({
      ...NotifytModalData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    const today = new Date();

    const from = formatDate(today);

    setFromDate(from);
    setToDate(from);

    fetchHealthCheckData(from,from);
  }, []);

  useEffect(() => {
    fetchCounts();
    fetchServiceTypes();
  }, []);

  useEffect(() => {
    fetchHealthCheckData();
  }, [selectedServiceType]);

  const handleRefresh = () => {
    window.location.reload();
  };

  // const closeLpModal = () => {
  //   const lpModalEl = document.getElementById("lp_modal");
  
  //   const lpModal = bootstrap.Modal.getInstance(lpModalEl);
  
  //   if (lpModal) {
  //     lpModal.hide();
  //   }
  
  //   setTimeout(() => {
  //     // remove stray backdrops
  //     document
  //       .querySelectorAll(".modal-backdrop")
  //       .forEach((el) => el.remove());
  
  //     // reset body
  //     document.body.classList.remove("modal-open");
  //     document.body.style.overflow = "";
  //     document.body.style.paddingRight = "";
     
  //   },);
  // };
  // useEffect(() => {
  //   const lpModal = document.getElementById("lp_modal");
  
  //   const handleClose = () => {
  //     // reopen device modal
  //     const deviceModalEl = document.getElementById("device_detail");
  
  //     if (deviceModalEl) {
  //       const deviceModal =
  //         bootstrap.Modal.getOrCreateInstance(deviceModalEl);
  
  //       deviceModal.show();
  //     }
  
  //     // cleanup stray backdrops
  //     document
  //       .querySelectorAll(".modal-backdrop")
  //       .forEach((el) => {
  //         if (!document.querySelector(".modal.show")) {
  //           el.remove();
  //         }
  //       });
  
  //     document.body.classList.remove("modal-open");
  //     document.body.style = "";
  //   };
  
  //   lpModal?.addEventListener("hidden.bs.modal", handleClose);
  
  //   return () => {
  //     lpModal?.removeEventListener("hidden.bs.modal", handleClose);
  //   };
  // }, []);

  return (
    <>
      <style>
        {`.col-2-4 {
  flex: 0 0 20%;
  max-width: 20%;
}
`}
      </style>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>HealthCheck</h4>
                <h6>Monitor your clients here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
            </ul>
          </div>

          <div className="row">
            <div className="col-2-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body ">
                  <div className="row align-items-center">
                    <div className="col-5">
                      <div>
                        <span className="fs-14 fw-normal  mb-1">
                          Total Clients
                        </span>
                        <h5>{counts?.TotalClients}</h5>
                      </div>
                    </div>
                    <div className="col-7 text-end">
                      <ReactApexChart
                        options={totalTransaction}
                        series={totalTransaction.series}
                        type="area"
                        width={60}
                        height={35}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body ">
                  <div className="row align-items-center">
                    <div className="col-5">
                      <div>
                        <span className="fs-14 fw-normal  mb-1">
                          Total Devices
                        </span>
                        <h5>{counts?.TotalDevices}</h5>
                      </div>
                    </div>
                    <div className="col-7 text-end">
                      <ReactApexChart
                        options={totalSubscription}
                        series={totalSubscription.series}
                        type="area"
                        width={60}
                        height={35}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2-4 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-7">
                      <div>
                        <span className="fs-14 fw-normal  mb-1">
                          Total Device Active
                        </span>
                        <h5>{counts?.TotalDevicesActive}</h5>
                      </div>
                    </div>
                    <div className="col-5">
                      <ReactApexChart
                        options={activeSubscription}
                        series={activeSubscription.series}
                        type="area"
                        width={60}
                        height={35}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2-4 col-md-6 d-flex">
              <div className="card flex-fill shadow-sm rounded-3">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-7">
                      <span className="fs-14 fw-normal d-block  mb-1">
                        Total Device Inactive
                      </span>
                      <h4 className="fw-bold mb-0">
                        {counts?.TotalDevicesInActive}
                      </h4>
                    </div>

                    <div className="col-5 d-flex justify-content-end">
                      <ReactApexChart
                        options={expiredSubscription}
                        series={expiredSubscription.series}
                        type="area"
                        width="65"
                        height="45"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2-4 col-md-6 d-flex">
              <div className="card flex-fill shadow-sm border-0 rounded-3">
                <div className="card-body py-3 px-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <span className="fs-14 fw-normal d-block mb-1">
                        Total Punches (Today)
                      </span>
                      <h3 className="fw-bold mb-0">
                        {counts?.TotalPunchesToday}
                      </h3>
                    </div>

                    {/* Chart Section */}
                    <div style={{ minWidth: "70px" }}>
                      <ReactApexChart
                        options={todaySubscription}
                        series={todaySubscription.series}
                        type="area"
                        width="70"
                        height="50"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              {/* <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Select
                    placeholder="Select Service Type"
                    style={{ width: 200 }}
                    loading={LoadingService}
                    options={serviceType}
                    onChange={(value) => setSelectedServiceType(value)}
                    value={selectedServiceType}
                  />
                </div>
                {/* <div className="dropdown">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFromDate(value);
                      fetchHealthCheckData(value);
                    }}
                    className="form-control"
                  />
                </div>
                <div className="dropdown">
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => {
                      const value = e.target.value;

                      setToDate(value);

                      fetchHealthCheckData(fromDate, value);
                    }}
                    className="form-control"
                  />
                </div> 
                 <div>
                <RangePicker
                  value={[
                    fromDate ? dayjs(fromDate) : null,
                    toDate ? dayjs(toDate) : null,
                  ]}
                  onChange={(dates, dateStrings) => {
                    const [from, to] = dateStrings;

                    setFromDate(from);
                    setToDate(to);

                    if (from && to) {
                      fetchHealthCheckData(from, to);
                    }
                  }}
                  format="YYYY-MM-DD"
                  className="form-control"
                  style={{ width: "100%" }}
                />
                </div>
              </div> */}
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-3">
                <div>
                  <Select
                    placeholder="Select Service Type"
                    style={{ width: 220 }}
                    loading={LoadingService}
                    options={serviceType}
                    onChange={(value) => setSelectedServiceType(value)}
                    value={selectedServiceType}
                  />
                </div>

                {/* Date Range Picker */}
                <div>
                  <RangePicker
                    value={[
                      fromDate ? dayjs(fromDate) : null,
                      toDate ? dayjs(toDate) : null,
                    ]}
                    onChange={(dates, dateStrings) => {
                      const [from, to] = dateStrings;

                      setFromDate(from);
                      setToDate(to);

                      if (from && to) {
                        fetchHealthCheckData(from, to);
                      }
                    }}
                    format="YYYY-MM-DD"
                    style={{
                      width: 280,
                      height: 38,
                      borderRadius: "6px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px",
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <Table1 columns={columns} dataSource={HealthCheckData} />
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      {/* Device Detail */}
      <div className="modal fade" id="device_detail">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                Devices for{" "}
                <span style={{ color: "orange" }}>{selectRecord?.OrgName}</span>
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={closeLpModal}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="card mb-0">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set py-3"></div>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  {orgDevicesLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "250px",
                      }}
                    >
                      <Spin size="large" />
                    </div>
                  ) : Array.isArray(orgDevices) && orgDevices.length > 0 ? (
                    <Table1 columns={deviceColumns} dataSource={orgDevices} />
                  ) : (
                    <p className="text-center text-muted">No data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* View Notification */}
      <div className="modal fade" id="Notification">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                Send Notification To Client
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={closeLpModal}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Client</label>
                    <input
                      type="text"
                      className="form-control"
                      name="OrgName"
                      value={NotifytModalData?.OrgName}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Subject"
                      value={NotifytModalData?.Subject}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Email To</label>
                    <input
                      type="email"
                      className="form-control"
                      name="PrimaryEmailAddr"
                      value={NotifytModalData?.PrimaryEmailAddr}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Contact</label>
                    <input
                      type="text"
                      className="form-control"
                      name="PrimaryMobile"
                      value={NotifytModalData?.PrimaryMobile}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="fw-medium">Notify Message Content</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="Message"
                      value={NotifytModalData?.Message}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="text-center">
                  <button
                    className="btn btn-success text-white"
                    onClick={sendWhatsAppNotification}
                  >
                    Notify
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {view all swipes} */}

      <div className="modal fade" id="lp_modal" >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                All Swipes Today In{" "}
                <span style={{ color: "orange" }}>
                  {selectedPunchDetails?.[0]?.OrgName || ""}
                </span>
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={closeLpModal}
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="card mb-0">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set py-3"></div>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  {punchListingLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "250px",
                      }}
                    >
                      <Spin size="large" />
                    </div>
                  ) : Array.isArray(selectedPunchDetails) &&
                    selectedPunchDetails.length > 0 ? (
                    <Table1
                      columns={swipeColumns}
                      dataSource={selectedPunchDetails}
                    />
                  ) : (
                    <p className="text-center text-muted">No data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthCheck;
